export default __webpack_public_path__ + "static/media/asesoramiento-hombre-bg.bf768bb5.png";